<template>
  <div id="id-video-share" :class="{ 'is-app': isFromApp }">
    <div class="mask"></div>
    <DownloadApp />
    <div class="video-container">
      <div id="id-qplayer-video"></div>
    </div>
  </div>
</template>
<script>
import DownloadApp from '../../components/DownloadApp'

export default {
  name: '',
  components: {
    DownloadApp
  },
  data () {
    return {
      // 播放器
      player: null
    }
  },
  mounted () {
    document.title = '鹏扬观点'
    this.isHJT()
    console.log('动态路由参数', this.$route.params)

    console.log('####### 视频')
    this.qPlayer()
    console.log('######## 结束')
  },
  methods: {
    qPlayer () {
      // todo 七牛云的 sdk 基本引入
      // eslint-disable-next-line no-new
      this.player = new QPlayer({
        url: 'http://demo-videos.qnsdk.com/movies/qiniu.mp4',
        container: document.getElementById('id-qplayer-video'),
        autoplay: true

        // defaultViewConfig: {
        // }
      })

      this.player.toggleMute()
    },
    // 判断是不是好基通自己的 webView
    isHJT () {
      let ua = navigator.userAgent
      let isPhone = ua.indexOf('iPhone') !== -1
      console.log('isPhone:', isPhone)
    }
  },
  computed: {
    isFromApp () {
      // return true
      var data = OpenInstall.parseUrlParams()
      return data.source === 'APP' || data.source === 'app'
    }
  }
}
</script>
<style
  lang="scss"
  scoped
>
#id-video-share {
  width: 100vw;
  height: 100vh;

  .mask {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    //background-color: #000;
    background-color: #000000;
    //opacity: 0.7;
    z-index: -1;
  }
  .video-container {
    width: 100vw;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    #id-qplayer-video {
      width: 100vw;
      height: 5.707rem;
      //background-color: pink;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/h5/VideoShare.vue